<template>
  <path
    d="M16.1498 13.6918H15.3819L15.1098 13.4294C16.0623 12.3213 16.6358 10.8828 16.6358 9.3179C16.6358 5.82847 13.8073 3 10.3179 3C6.82847 3 4 5.82847 4 9.3179C4 12.8073 6.82847 15.6358 10.3179 15.6358C11.8828 15.6358 13.3213 15.0623 14.4294 14.1098L14.6918 14.3819V15.1498L19.5517 20L21 18.5517L16.1498 13.6918ZM10.3179 13.6918C7.89766 13.6918 5.94397 11.7381 5.94397 9.3179C5.94397 6.89766 7.89766 4.94397 10.3179 4.94397C12.7381 4.94397 14.6918 6.89766 14.6918 9.3179C14.6918 11.7381 12.7381 13.6918 10.3179 13.6918Z"
  />
</template>
